import { render, staticRenderFns } from "./EstimationSection.vue?vue&type=template&id=0fea8568&scoped=true&"
import script from "./EstimationSection.vue?vue&type=script&lang=js&"
export * from "./EstimationSection.vue?vue&type=script&lang=js&"
import style0 from "./EstimationSection.vue?vue&type=style&index=0&id=0fea8568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea8568",
  null
  
)

export default component.exports